import { TextFilterProps } from '@progress/kendo-react-data-tools'
import { useAppSelector } from 'store'

import { SelectFilter } from '../SelectFilter'

export const SelectWalletTypeFilter: React.FC<TextFilterProps> = (props) => {
  const { filter, onFilterChange } = props
  const walletTypes = useAppSelector((state) => state.wallet.walletType)

  const data = walletTypes.map((x) => ({ id: x.id, label: x.name, value: x.id }))

  return <SelectFilter filter={filter} onFilterChange={onFilterChange} data={data} />
}
